import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconFolder",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, f, a) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--folder"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Folder",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.94 1.44A1.5 1.5 0 0 1 2 1h1.968a1.5 1.5 0 0 1 1.242.671l.413.604a.5.5 0 0 0 .414.225H10A1.5 1.5 0 0 1 11.5 4v5a1.5 1.5 0 0 1-1.5 1.5H2C1.174 10.5.5 9.826.5 9V2.5c0-.398.158-.78.44-1.06ZM2 2a.5.5 0 0 0-.5.5V9c0 .274.226.5.5.5h8a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H6.032a1.5 1.5 0 0 1-1.242-.671l-.413-.604A.5.5 0 0 0 3.963 2H2Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=folder.js.map
